<div [formGroup]="formGroup" class="row">
  <div class="col-1-4">
    <label class="label" [innerHTML]="question.title"></label>
  </div>

  <div class="col">
    <div>
        <input type="checkbox" title="{{ 'registration-form.caribbean' | translate }}" [id]="caribisch" [formControl]="caribianControl" (change)="setCaribisch()" />
        <label [for]="caribisch" class="label">{{ 'registration-form.caribbean' | translate }}</label>
    </div>
      <div class="search-container" *ngIf="caribianControl.value !== true">
          <div class="input-search">
            <input type="text" placeholder="{{ placeholder }}" title="{{ question.description }}" [formControlName]="question.inputKey" [id]="question.inputKey"
            [value]="question.value" (blur)="onSearch()" (keydown)="onKeyDown($event)"/>
        </div>
        <div class="search-button">
            <button (click)="onSearch()" class="right" type="button"><i class="icon-zoekveld"></i></button>
        </div>
    </div>

    <div class="error-summary" *ngIf="question.control && question.control.errors && (question.control.dirty || question.control.touched || submitted)">
      <div class="error" *ngIf="question.control.errors.required">{{ 'registration-form.validation-required' | translate }}</div>
      <div class="error" *ngIf="question.control.errors.minlength">{{ 'registration-form.validation-minlength' | translate }}</div>
      <div class="error" *ngIf="question.control.errors.maxlength">{{ 'registration-form.validation-maxlength' | translate }}</div>
      <div class="error" *ngIf="question.control.errors.pattern && (question.inputType === 'text' || question.inputType === 'number') ">{{ 'registration-form.validation-pattern' | translate }}</div>
      <div class="error" *ngIf="question.control.errors.pattern && question.inputType === 'email'">{{ 'registration-form.validation-email' | translate }}</div>
      <div class="error" *ngIf="question.control.errors.pattern && question.inputType === 'url'">{{ 'registration-form.validation-url' | translate }}</div>
      <div class="error" *ngIf="question.control.errors.pattern && question.inputType === 'tel'">{{ 'registration-form.validation-tel' | translate }}</div>
      <div class="error" *ngIf="question.control.errors.server">{{question.control.errors.server}}</div>
      <div class="error" *ngIf="question.control.errors.notfound">{{ 'registration-form.coc-notfound' | translate }}</div>
      <div class="error" *ngIf="question.control.errors.badrequest">{{ 'registration-form.coc-badrequest' | translate }}</div>
    </div>
    <div class="description" *ngIf="question.displayDescription">
      {{ question.description }}
    </div>
  </div>
  <div class="col-1-100">
    <button *ngIf="question.description !== undefined && !question.displayDescription" (click)="question.displayDescription = true"
      class="right" type="button">?</button>
    <button *ngIf="question.description !== undefined && question.displayDescription" (click)="question.displayDescription = false"
      class="right" type="button">x</button>
  </div>
</div>